import React from "react";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";

const dateFormat = "d.L.yyyy HH:mm:ss";

export default observer(function HeaderLoginHistory() {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();
	const loginHistory = rootStore.userAuthStore.loginHistory;

	if (loginHistory == null) {
		return <div>{t<string>("HEADER.FIRST_LOGIN")}</div>;
	}

	const lastLogin = DateTime.fromISO(loginHistory.lastLogin).toFormat(
		dateFormat
	);
	const currentLogin = DateTime.fromISO(loginHistory.currentLogin).toFormat(
		dateFormat
	);

	return (
		<>
			<div>
				{t<string>("LOGIN_HISTORY.LAST_LOGIN", {
					date: lastLogin,
				})}
			</div>
			<div>
				{t<string>("LOGIN_HISTORY.LOGGED_IN_FROM", {
					date: currentLogin,
				})}
			</div>
		</>
	);
});
